<template lang='pug'>
v-container.pa-0(fluid)
  v-app-bar(app, flat, dense, fixed)
    v-app-bar-nav-icon(@click="toggleDrawerMenu")
    v-toolbar-title.subtitle-1 メンバータグ
  v-container(fluid)
    v-row
      table.member-activity-table.ma-3
        tr
          th 名前
          th 説明
          th
            v-btn(color="primary", small, @click="prepareToAdd") メンバータグ追加
        tr(v-for="item in informations", :key="item.informationBoardId")
          td {{ item.name }}
          td {{ item.description }}
          td 
            v-btn(color="primary", text, small, @click="prepareToEdit(item)") 修正
            v-btn(color="error", text, small, @click="prepareToDelete(item)") 削除
    v-dialog(v-model="dialogDeleting", max-width="400")
      v-card
        v-card-title Koos Workspace
        v-card-text メンバータグを削除してよろしいですか。
        v-card-text {{ objectToDelete.name }}
        v-card-actions
          v-spacer
          v-btn(text, @click="dialogDeleting = false") キャンセル
          v-btn(text, @click="deleteMemberTag(objectToDelete)") OK

    v-dialog(v-model="dialogAdding", max-width="800")
      v-card
        v-card-title Koos Workspace
        v-card-text メンバータグを{{ addingObj.memberTagId == null ? '追加' : '編集' }}します。
        v-card-text
          v-text-field(v-model="addingObj.name", label="名前") 
          v-text-field(v-model="addingObj.description", label="説明") 
        v-card-title(v-if="addingObj.memberTagId != null") 含まれるメンバー
        v-card-text(v-if="addingObj.memberTagId != null")
          v-chip.ma-1(
            v-for="item in addingObj.assignedUsers",
            :key="item",
            close,
            small,
            color="green",
            @click="removeUser(item)",
            @click:close="removeUser(item)"
          ) {{ item }}
        v-card-title(v-if="addingObj.memberTagId != null") 含まれないメンバー
        v-card-text(v-if="addingObj.memberTagId != null")
          v-chip.ma-1(
            v-for="item in addingObj.unassignedUsers",
            :key="item",
            small,
            outlined,
            color="blue",
            @click="addUser(item)"
          ) {{ item }}
        v-card-actions
          v-spacer
          v-btn(text, @click="dialogAdding = false") キャンセル
          v-btn(text, @click="confirmAdding") OK
</template>

<script>
import basic from "@/components/mixins/basic";
import moment from "moment-timezone";
import { detect } from "detect-browser";
moment.locale("ja");

export default {
  mixins: [basic],
  components: {},
  computed: {
    firstCalendars() {
      return this.members.length > 0 ? this.members[0].dates : [];
    },
  },
  data() {
    return {
      informations: [],
      targetDate: null,
      startDay: null,
      endDay: null,
      dialogWorkType: false,
      dateStyle: "picker",
      timeStyle: "text",
      addingObj: {},
      dialogAdding: false,
      objectToDelete: {},
      dialogDeleting: false,
    };
  },
  mounted() {
    this.browser = detect();
    if (this.browser !== null) {
      if (
        this.browser.os.includes("iOS") ||
        this.browser.os.includes("Android")
      ) {
        this.dateStyle = "input";
        this.timeStyle = "time";
      }
    }
    this.yearMonthDate = moment([moment().year(), moment().month(), 1]);
  },
  methods: {
    async masterReady() {
      if (!this.$store.getters["Login/isAdmin"]) {
        // redirect to home when you are not admin
        this.$router.push(this.site.deployFolder + "/");
      }
      await this.search();
    },
    async search() {
      this.informations = await this.$store.dispatch("MemberTags/listAll", 2);
    },
    prepareToAdd() {
      this.addingObj = {
        name: "",
        description: "",
        memberTagId: null,
        isPersonal: false,
      };
      this.dialogAdding = true;
    },
    prepareToDelete(item) {
      this.objectToDelete = item;
      this.dialogDeleting = true;
    },
    prepareToEdit(item) {
      this.addingObj = JSON.parse(JSON.stringify(item));
      this.dialogAdding = true;
    },
    addUser(item) {
      this.addingObj.unassignedUsers = this.addingObj.unassignedUsers.filter(
        (element) => element != item
      );
      this.addingObj.assignedUsers.push(item);
    },
    removeUser(item) {
      this.addingObj.assignedUsers = this.addingObj.assignedUsers.filter(
        (element) => element != item
      );
      this.addingObj.unassignedUsers.push(item);
    },
    async confirmAdding() {
      this.dialogAdding = false;
      this.requestParam = this.addingObj;
      this.requestParam.isPersonal = false;
      await this.$store.dispatch("MemberTags/add", this.requestParam);
      this.dispSuccess("メンバータグを追加しました。");
      this.search();
    },
    async deleteMemberTag(item) {
      await this.$store.dispatch("MemberTags/delete", item.memberTagId);
      this.dialogDeleting = false;
      this.dispSuccess("メンバータグを削除しました。");
      this.search();
    },
    toggleDrawerMenu() {
      this.$emit("toggle");
    },
  },
};
</script>

<style>
.timerow {
  border-bottom-style: solid;
  border-bottom-width: 1pt;
  border-bottom-color: lightgray;
}
.timecell {
  background-color: transparent !important;
}
.odd {
  background-color: rgb(232, 232, 232);
}
.user-table td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.user-image {
  width: 40px;
  height: 40px;
  border-radius: 20%;
  border-style: solid;
  border-width: 0.5px;
  border-color: lightgray;
}
.inactive {
  -webkit-filter: grayscale() opacity(0.5);
  filter: grayscale() opacity(0.5);
}
/* .timeinput fieldset {
  border-color: rgb(210, 210, 210) !important;
  height: 41px !important;
  background-color: white !important;
}
*/
.timesheet-table {
  width: 100%;
}

label.v-label {
  font-size: 0.8em !important;
}
.centered-input input {
  text-align: center;
}
.member-plan-cell {
  font-size: 0.7em;
}
.member-activity-table {
  padding: 0em 2em;
  border-collapse: collapse;
  border-left-style: solid;
  border-left-width: 1px;
  border-left-color: #ccc;
  border-top-style: solid !important;
  border-top-width: 1px;
  border-top-color: #ccc;
}
.member-activity-table td {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
}
.member-activity-table th {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.approve-title {
  font-weight: bold;
  color: black !important;
}
.list-input-group {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  align-items: center;
  min-height: 2rem;
}
</style>